module.exports = __webpack_public_path__ + "static/img/cont2601.4ee0ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2601.jpg
// module id = PUMJ
// module chunks = 0